import { NavLink } from "react-router-dom";

interface HeaderProps {
  nextTheme: string;
  setTheme: (theme: string) => void;
}

export default function Header({ nextTheme, setTheme }: HeaderProps) {
  return (
    <header className="relative py-8 text-center border-b dark:border-slate-800 bg-white dark:bg-slate-950 transition-colors duration-300">
      <h1 className="text-4xl font-bold tracking-wide dark:text-white">
        THE STRUCTURE OF EARNINGS NEWS
      </h1>
      <nav className="mt-3 flex justify-center gap-8 text-gray-600 dark:text-slate-400 font-medium">
        <NavLink
          to="/"
          className={({ isActive }) =>
            isActive
              ? "text-emerald-700 dark:text-emerald-400 font-semibold underline underline-offset-4"
              : "hover:text-emerald-600 dark:hover:text-emerald-300 transition-colors"
          }
        >
          About
        </NavLink>
        <NavLink
          to="/analysis"
          className={({ isActive }) =>
            isActive
              ? "text-emerald-700 dark:text-emerald-400 font-semibold underline underline-offset-4"
              : "hover:text-emerald-600 dark:hover:text-emerald-300 transition-colors"
          }
        >
          Analysis
        </NavLink>
        <NavLink
          to="/comparison"
          className={({ isActive }) =>
            isActive
              ? "text-emerald-700 dark:text-emerald-400 font-semibold underline underline-offset-4"
              : "hover:text-emerald-600 dark:hover:text-emerald-300 transition-colors"
          }
        >
          Comparison
        </NavLink>
        <NavLink
          to="/topics"
          className={({ isActive }) =>
            isActive
              ? "text-emerald-700 dark:text-emerald-400 font-semibold underline underline-offset-4"
              : "hover:text-emerald-600 dark:hover:text-emerald-300 transition-colors"
          }
        >
          Topic Details
        </NavLink>
      </nav>

      <div className="absolute top-8 right-8 flex justify-center items-center gap-3">
        <span className="hidden md:inline text-xs uppercase tracking-widest text-gray-400 dark:text-slate-500 font-bold">
          {nextTheme === "dark" ? "Light" : "Dark"} Mode
        </span>
        <label className="relative inline-flex items-center cursor-pointer">
          <input
            type="checkbox"
            className="sr-only peer"
            checked={nextTheme === "light"}
            onChange={() => setTheme(nextTheme)}
          />
          <div className="w-14 h-7 bg-gray-200 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-7 peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[4px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-6 after:w-6 after:transition-all dark:border-gray-600 peer-checked:bg-blue-500"></div>
        </label>
      </div>
    </header>
  );
}
